import { useEffect } from "react"
import { customScript } from "../../common/customscript"
import Blog_Detail from "../../components/blog_detail/blog_detail"
import Footer from "../../components/footer/footer"
import Header from "../../components/header/header"
import SearchModel from "../../components/search_model/search"

const BlogDetail = () => {
    useEffect(() => {
        customScript()
    }, [])
    return (
        <>
            <Header />
            <Blog_Detail />
            <Footer />
            <SearchModel />
        </>
    )
}

export default BlogDetail